export default [
  {
    path: '/active-newyear2024/index',
    name: 'index',
    component: () => import('@/views/active-newyear2024/index'),
    meta: {
      title: '2024新年狂欢，许愿赢返现红包-高考直通车'
    }
  },
]
